@if (params.isNotExtendableDropDown) {
  <ng-select
    #ngSelect
    class="ag-not-extendable-attribute-dropdown"
    [formControl]="attributeControl"
    [items]="poOptions()"
    [searchable]="true"
    bindLabel="label"
    bindValue="value"
    appendTo="body"
    data-pendo-id="po-attribute-column-select"
    (close)="stopEditing()"
    (change)="setIsOpen(false)"
    [clearable]="!params.hideClearButton"
    [isOpen]="isOpen"
  >
    <ng-template ng-option-tmp let-item="item" let-index="item">
      <div
        #text
        class="truncate"
        [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.label : ''"
        auxTooltipPanelContainerClass="ag-not-extendable-attribute-dropdown-tooltip"
      >
        {{ item.label }}
      </div>
    </ng-template>
  </ng-select>
} @else {
  <aux-extendable-options-dropdown
    class="attributes-dropdown"
    [items]="items()"
    [dropdownControl]="attributeControl"
    [openOnInit]="true"
    [resetValueOnEscapePress]="true"
    [initialSearchTerm]="initialSearchTerm"
    (clickOut)="stopEditing()"
    (confirm)="stopEditing()"
    (addOption)="onAddOption($event)"
    (changed)="$event && stopEditing()"
  />
}
